import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AutocompleteSuggestion } from '~/component/form/autocomplete/interfaces/suggestion.interface';

import { ListStyleEnum } from './enum/list-style.enum';

@Component({
  selector: 'app-form-autocomplete-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class FormAutocompleteListComponent {
  @Input() public isOpen = false;
  @Input() public listStyle = ListStyleEnum.Default;
  @Input() public suggestions: AutocompleteSuggestion[] = [];
  @Input() public triggerId: string;

  @Output() public readonly selectSuggestion = new EventEmitter();

  public get listClass(): string {
    return (
      this.listStyle === ListStyleEnum.Shadowed &&
      'form-autocomplete-list--shadowed'
    );
  }

  public setSelectedSuggestion(suggestion: AutocompleteSuggestion): void {
    this.selectSuggestion.emit(suggestion);
  }
}
